export const CREATE_INVOICE_ERROR_NOTIFICATION_DELAY_FOCUS = 100;
